import { handleRefreshes } from "./handleRefreshes";
export function refreshBoards() {
    const refreshBtn = document.querySelector("#refresh");
    const refreshStatus = document.querySelector("#refresh-status");
    refreshBtn.addEventListener("click", () => {
        refreshStatus.innerHTML = "Loading...";
        handleRefreshes(true, {
            request: () => {
                refreshStatus.innerHTML = `Initializing refresh...`;
            },
            error: (error) => {
                refreshStatus.innerHTML = "Sorry, something went wrong.";
                console.error(error);
            },
            success: (count) => {
                if (count > 0) {
                    refreshStatus.innerHTML = `Successfully refreshed (${count})`;
                }
                else {
                    refreshStatus.innerHTML = `Sorry, no active boards to refresh.`;
                }
            },
        });
    });
}
